import { Loading } from "../components/Loading";
import useLoadingStore from "../store/useLoadingState";
import useModalStore from "../store/useModalStore";
import { Header } from "./header";
import { Main } from "./main";
import { PeriodFilterModal } from "./periodFilterModal";
import { StyledPotholeFilterStatus } from "./style";

export const PotholeFilterStatus = () => {
  const { isPeriodFilterModal } = useModalStore();
  const { isLoading } = useLoadingStore();
  return (
    <StyledPotholeFilterStatus>
      <Header />
      <Main />

      {isPeriodFilterModal && <PeriodFilterModal />}
      {isLoading && <Loading />}
    </StyledPotholeFilterStatus>
  );
};
